<template>
    <motion.div initial="hidden" animate="visible" :transition="fieldStagger" class="flex flex-col gap-5">
        <vx-expandable-card>
            <template v-slot:header>
                <motion.div :variants="fadeUpVariants" :transition="quickTransition">
                    <span>Categories</span>
                </motion.div>
            </template>

            <template v-slot:headerSubtitle>
                <motion.div :variants="fadeUpVariants" :transition="quickTransition"
                    >Configure how the AI classifies conversations.</motion.div
                >
            </template>

            <template v-slot:content>
                <div class="flex flex-col gap-6">
                    <motion.div :variants="fadeUpVariants" :transition="quickTransition" class="flex flex-col gap-2">
                        <intelligent-inbox-category-card
                            v-for="category in categories"
                            :key="category.id"
                            :category="category"
                            @edit="openEdit"
                            @delete="confirmRemove"
                        />
                        <div class="flex">
                            <vx-box class="p-4">
                                <vx-button size="lg" @click.stop="openCreate()">
                                    New Category <font-awesome-icon :icon="faCirclePlus"></font-awesome-icon>
                                </vx-button>
                            </vx-box>
                        </div>
                    </motion.div>
                </div>
            </template>
        </vx-expandable-card>

        <modal-intelligent-category
            v-model:visible="modalVisible"
            :categoryId="modalCategoryId"
        ></modal-intelligent-category>
    </motion.div>
</template>

<script lang="ts" setup>
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxBox, VxButton, VxExpandableCard, VxSwal } from '@voxie/frontend-components';
import { motion } from 'motion-v';
import { ref } from 'vue';
import { useIntelligentInbox } from '../useIntelligentInbox';
import type { IntelligentCategory } from '../useIntelligentInbox';
import ModalIntelligentCategory from '../ModalIntelligentCategory.vue';
import IntelligentInboxCategoryCard from '../IntelligentInboxCategoryCard.vue';
import { fadeUpVariants, fieldStagger, quickTransition } from './wizardMotionVariants';

const { categories, removeCategory } = useIntelligentInbox();

const modalVisible = ref(false);
const modalCategoryId = ref('');

const openCreate = (): void => {
    modalCategoryId.value = '';
    modalVisible.value = true;
};

const openEdit = (category: IntelligentCategory): void => {
    modalCategoryId.value = category.id;
    modalVisible.value = true;
};

const confirmRemove = async (category: IntelligentCategory): Promise<void> => {
    const result = await VxSwal.fire({
        title: 'Delete Category',
        text: `Are you sure you want to delete "${category.displayName}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'danger',
        confirmButtonText: 'Delete',
    });

    if (result.isConfirmed) {
        removeCategory(category.id);
    }
};
</script>
